import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Segment} from 'semantic-ui-react';

import {createForm} from '@utils/forms';
import EventsInvoiceStatusForm from '@modules/events/forms/EventsInvoiceStatusForm';
import EventsInvoiceStatusModel from '@modules/events/forms/EventsInvoiceStatusModel';
import SegmentHeader from '@appComponents/SegmentHeader';

export const EventsInvoiceStatus = memo(({eventId}) => {
    const Form = createForm(
        EventsInvoiceStatusModel,
        EventsInvoiceStatusForm, {
            optionsVariables: {event: eventId},
        }
    );

    return <>
        <SegmentHeader>Invoice status</SegmentHeader>
        <Segment basic>
            <Form/>
        </Segment>
    </>;
});

EventsInvoiceStatus.displayName = 'EventsInvoiceStatus';

EventsInvoiceStatus.propTypes = {
    eventId: PropTypes.number,
};
